import { Injectable } from '@angular/core';
import { OidcConfigService } from './oidc-config.service';
import { BehaviorSubject, from, fromEvent, Observable } from 'rxjs';
import { catchError, map, mapTo } from 'rxjs/operators';
import { OiamEvents } from './oidc-events.enum';
import { Status } from '../../../core/enums/status';
import { HttpErrorResponse } from '@angular/common/http';
import { ApiService } from '../../../core/services/api/api.service';
import * as hummel from '@websso/oiam-oauth-types';
import { RoutingService } from '../../../core/services/routing.service';
import { environment } from '../../../../environments/environment';
import { OidcScriptInjectorService } from './oidc-script-injector.service';

@Injectable({
    providedIn: 'root',
})
export class OidcService {
    authTokenSubject = new BehaviorSubject<string>(null);
    authToken$ = this.authTokenSubject.asObservable();

    constructor(private oidcConfigService: OidcConfigService,
                private apiService: ApiService,
                private _routerService: RoutingService,
                private _oidcScriptInjector: OidcScriptInjectorService) {}

    login(): void {
        self.dispatchEvent(new CustomEvent(OiamEvents.OIAM_LOGIN_EVENT));
    }

    logout() {
        self.dispatchEvent(new CustomEvent(OiamEvents.OIAM_LOGOUT_EVENT));
    }

    isLoginDetectable$(): Observable<boolean> {
        return fromEvent(self, OiamEvents.OIAM_TOKEN_EVENT).pipe(mapTo(true));
    }

    initOidcWebcomponent() {
        this._oidcScriptInjector.injectOidcComponentScripts();
        window.addEventListener(OiamEvents.OIAM_LOADED_EVENT, () => this.oidcConfigService.setConfig(), { once: true });
        window.addEventListener(OiamEvents.OIAM_TOKEN_EVENT, (e: CustomEvent) => this._extractAccessToken(e));
        window.addEventListener(OiamEvents.OIAM_CUSTOMSTATE, (event: CustomEvent) => {
            if( this.oidcConfigService.isValidCustomState(event.detail.customstate)) {
            this._routerService.navigate([`${environment.uiHost}${event.detail.customstate}`]);
            ;
        }});
    }


    getValidToken$(): Observable<string> {
        const tokenEnsurer = new hummel.TokenEnsurer();
        return from(
            tokenEnsurer
                .ensureValidToken(this.authTokenSubject.value)
                .then((updatedToken) => {
                    this.authTokenSubject.next(updatedToken);
                    return updatedToken;
                })
                .catch((error) => {
                    console.log(error);
                    return null;
                })
        );
    }

    isLoggedIn(): boolean {
        return !!this.authTokenSubject.value;
    }

    isTokenValid$ = (): Observable<boolean> => {
        return this.apiService
            .get('/guard')
            .pipe(catchError(this._handleTokenCheckError), map(this._handleTokenCheckAnswer));
    };



    private _extractAccessToken(event: CustomEvent): void {
        if (event.detail?.jwt) {
            this.authTokenSubject.next(event.detail.jwt);
        }
    }



    private _handleTokenCheckAnswer({ status }: { status: Status }): boolean {
        return status === Status.OK;
    }

    private _handleTokenCheckError(error: HttpErrorResponse): Status {
        if (error) {
            return Status.KEINE_BERECHTIGUNG;
        }
        throw error;
    }

}
